// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MainTypes;
(function (MainTypes) {
    MainTypes[MainTypes["AUCTION_PRE_OPEN"] = 0] = "AUCTION_PRE_OPEN";
    MainTypes[MainTypes["MAIN_CONTINUOUS1"] = 1] = "MAIN_CONTINUOUS1";
    MainTypes[MainTypes["MAIN_CONTINUOUS2"] = 2] = "MAIN_CONTINUOUS2";
    MainTypes[MainTypes["CONTINUOUS_PRE"] = 3] = "CONTINUOUS_PRE";
    MainTypes[MainTypes["AUCTION_PRE_CLOSE"] = 4] = "AUCTION_PRE_CLOSE";
    MainTypes[MainTypes["AUCTION_PRE_MAIN_OPEN"] = 5] = "AUCTION_PRE_MAIN_OPEN";
    MainTypes[MainTypes["AUCTION_OPEN"] = 6] = "AUCTION_OPEN";
    MainTypes[MainTypes["IN_BETWEEN_CLEARING"] = 7] = "IN_BETWEEN_CLEARING";
    MainTypes[MainTypes["AUCTION_CLOSE"] = 8] = "AUCTION_CLOSE";
    MainTypes[MainTypes["CLEARING"] = 9] = "CLEARING";
    MainTypes[MainTypes["SETTLEMENT_CLEARING"] = 10] = "SETTLEMENT_CLEARING";
    MainTypes[MainTypes["FINAL_SETTLEMENT_CLEARING"] = 11] = "FINAL_SETTLEMENT_CLEARING";
    MainTypes[MainTypes["AUCTION_POST_OPEN"] = 12] = "AUCTION_POST_OPEN";
    MainTypes[MainTypes["AUCTION_POST_CLOSE"] = 13] = "AUCTION_POST_CLOSE";
    MainTypes[MainTypes["CONTINUOUS_POST"] = 14] = "CONTINUOUS_POST";
})(MainTypes || (MainTypes = {}));
